import { render, staticRenderFns } from "./MixerTableMobile.vue?vue&type=template&id=b2d90d5e&scoped=true&lang=pug"
import script from "./MixerTableMobile.vue?vue&type=script&lang=js"
export * from "./MixerTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d90d5e",
  null
  
)

export default component.exports